import { Container } from '@mui/material'
import { Box } from '@mui/system'
import { useResponsive } from 'hooks/useResponsive'
import { ReactNode } from 'react'

const PageContainer = ({ children }: { children: ReactNode[] | ReactNode }) => {
  const { isDesktop } = useResponsive()
  return (
    <Container
      sx={{
        minHeight: 'calc(100vh - 100px)',
      }}
    >
      <Box
        sx={{
          paddingX: isDesktop ? '40px' : '0px',
          paddingY: '50px',
          display: 'flex',
          flexDirection: 'column',
          gap: '40px',
          marginY: '100px',
        }}
      >
        {children}
      </Box>
    </Container>
  )
}

export default PageContainer

export const PageContainerCenter = ({
  children,
}: {
  children: ReactNode[] | ReactNode
}) => {
  return (
    <Container
      sx={{
        minHeight: '100vh',
      }}
    >
      <Box
        sx={{
          minHeight: 'calc(100vh - 200px)',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingY: '100px',
        }}
      >
        {children}
      </Box>
    </Container>
  )
}
